export default __webpack_public_path__ + "static/cp-big-picture-c8a02c6b7d6e07b0f42bcdf612f7b439.webm";